module.exports = __webpack_public_path__ + "static/o-t-04-f1553e32ce9b1612f0ca9932e87fe7db.jpg";